// src/plugins/vuetify.js
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from 'vue';

import Vuetify, {
  VAlert,VApp,VAppBar,VAppBarNavIcon,VAvatar,
  VBtn,
  VCard,VCardActions,VCardSubtitle,VCardTitle,VCardText,VCarousel,VCarouselItem,VCarouselTransition,VCarouselReverseTransition,VChipGroup,VChip,VCol,VContainer,
  VDivider,
  VFlex,
  VIcon,
  VImg,
  VLayout,VList,VListItem,VListItemTitle,VListItemActionText,VListItemContent,VListItemIcon,VListItemGroup,
  VNavigationDrawer,
  VProgressCircular,
  VProgressLinear,
  VRow,
  VSheet,VSpacer,
  VTabsSlider,VTabs,VTab,VTabsItems,VTabItem,VTabTransition,VTabReverseTransition,VToolbarTitle,
  VSlideGroup,VSlideItem,VSlideYTransition,
} from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  components: {
    VAlert,VApp,VAppBar,VAppBarNavIcon,VAvatar,
    VBtn,
    VCard,VCardActions,VCardSubtitle,VCardTitle,VCardText,VCarousel,VCarouselItem,VCarouselTransition,VCarouselReverseTransition,VChipGroup,VChip,VCol,VContainer,
    VDivider,
    VFlex,
    VIcon,
    VImg,
    VLayout,VList,VListItem,VListItemTitle,VListItemActionText,VListItemContent,VListItemIcon,VListItemGroup,
    VNavigationDrawer,
    VProgressCircular,
    VProgressLinear,
    VRow,
    VSheet,VSpacer,
    VTabsSlider,VTabs,VTab,VTabsItems,VTabItem,VTabTransition,VTabReverseTransition,VToolbarTitle,
    VSlideGroup,VSlideItem,VSlideYTransition,
  },
  directives: {
    Ripple,
  }
});

const opts = {
  theme: {
    options: {
      customProperties: true,
    },
    // themes: {
    // 	light: {
    // 		primary: '#4A90E2',
    // 		darkPrimary: '#3B73B4',
    // 		secondary: '#424242',
    // 		accent: '#82B1FF',
    // 		error: '#a70000',
    // 		info: '#2196F3',
    // 		success: '#4CAF50',
    // 		warning: '#FFC107',
    // 		teal: '#64EBC6',
    // 		green: '#7ED321',
    // 		darkGreen: '#4c8f1d',
    // 		lightGrey: 'rgba(0,0,0,0.12)',
    // 		darkGrey: '#4A4A4A',
    // 		textSecondary: 'rgba(0,0,0,0.4)',
    // 	},
    // },
  },
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
};

export default new Vuetify(opts);
